<template>
  <input
    v-mask="mask"
    :value="props.value"
    placeholder="0.00"
    class="input"
    autocomplete="off"
    autocapitalize="off"
    autocorrect="off"
    spellcheck="false"
    pattern="^[0-9]+([\.,][0-9]+)?$"
    inputmode="decimal"
    @accept="onAccept"
    @blur="onBlur"
  />
</template>

<script lang="ts" setup>
import { IMaskDirective as vMask } from 'vue-imask';
import { matchAmountsWithPrecision } from '@/utilities/matchAmountsWithPrecision';

const props = withDefaults(defineProps<{
  value: string,
  digits: number,
}>(), {
  digits: 2,
});

const emit = defineEmits<{
  (e: 'input', value: string): void,
}>();

const mask = {
  mask: [
    {
      mask: Number,
      scale: 2,
      radix: '.',
      mapToRadix: ['.', ','],
      normalizeZeros: false,
      min: 0,
    },
    {
      mask: Number,
      scale: 8,
      radix: '.',
      mapToRadix: ['.', ','],
      normalizeZeros: false,
      min: 0,
    },
  ],
  dispatch: (a, dynamicMasked) => dynamicMasked.compiledMasks.find(m => m.scale === props.digits),
};

const onAccept = (e) => {
  while (e.detail.value.match(/^0\d/) || e.detail.value.startsWith('.')) {
    e.detail.value = e.detail.value.slice(1);
  }

  const { value } = e.detail;

  const isMatch = matchAmountsWithPrecision(props.value, value, props.digits);

  if (!isMatch && value) {
    emit('input', value);
  }
};

const onBlur = (e) => {
  const { value } = e.target;

  if (!Number(value)) {
    emit('input', '');
  }
};
</script>

<style scoped lang="scss">
@import "@scss-vars";

.input {
  font-family: Graphik-Semibold, Arial Bold, Arial, sans-serif;
  font-size: rem(24);
  line-height: rem(28);
  height: 100%;
  min-width: 0;
  padding: 0 rem(14);
  box-shadow: none;

  &:focus {
    outline: none;
  }

  &::-webkit-contacts-auto-fill-button {
    visibility: hidden;
  }
}
</style>